import moment from 'moment'

interface FriendlyDateTimeProps {
  datetime: string
  short?: boolean
  full?: boolean
  diff?: boolean
  className?: string
}
export function FriendlyDateTime ({ datetime, short, full, diff, className }: FriendlyDateTimeProps): JSX.Element {
  const stdDate = 'MM/DD/YYYY'
  const stdTime = 'HH:mm'
  const stdDateTime = `${stdDate} ${stdTime}`

  const shortOptions = {
    sameDay: `[Today at] ${stdTime}`,
    nextDay: `[Tomorrow at] ${stdTime}`,
    nextWeek: stdDateTime,
    lastDay: `[Yesterday at] ${stdTime}`,
    lastWeek: stdDateTime,
    sameElse: stdDateTime
  }

  const fullOptions = {
    sameDay: stdDateTime,
    nextDay: stdDateTime,
    nextWeek: stdDateTime,
    lastDay: stdDateTime,
    lastWeek: stdDateTime,
    sameElse: stdDateTime
  }

  const defaultOptions = {
    sameDay: `[Today at] ${stdTime}`,
    nextDay: `[Tomorrow at] ${stdTime}`,
    nextWeek: `dddd [at] ${stdTime}`,
    lastDay: `[Yesterday at] ${stdTime}`,
    lastWeek: `[Last] dddd [at] ${stdTime}`,
    sameElse: stdDateTime
  }

  let options
  if (full && short) {
    options = fullOptions
  } else if (full && !short) {
    options = fullOptions
  } else if (!full && short) {
    options = shortOptions
  } else {
    options = defaultOptions
  }

  const result = moment(datetime).calendar(null, options)

  if (datetime) {
    if (diff) {
      return (
        <span
          title={result}
          className={className}
        >
          {moment(datetime).fromNow()}
        </span>
      )
    }

    return (
      <span className={className}>
        {result}
      </span>
    )
  }

  return (
    <span className={className} />
  )
}
